import axios from 'axios';
import { navigate } from 'gatsby';
import { captureException } from '@sentry/gatsby';

export const downloadFile = async (filename, downloadUrl) => {
  const response = await axios.get(downloadUrl, {
    responseType: 'blob',
  });
  const blob = response.data;
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'true');
  link.setAttribute('target', '_blank');
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  window.open(link.href);
  document.body.removeChild(link);
};

export const downloadAsset = (downloadName, downloadUrl) => {
  try {
    if (downloadUrl) downloadFile(downloadName, downloadUrl);
    navigate('/resources/asset-operations-maintenance-hub');
  } catch (error) {
    captureException(`Download Form Error - ${error}`);
    console.error(error);
  }
};
